/**
 * **NOTE** The styles in this file are a direct copy of the styles found at:
 * `src/modules/templateEditor/EditWhatsApp/preview/`.
 *
 * Like everything else in this module, this work exists under the assumption that it is temporary.
 * We _should_ be using the templateEditor module's preview for this module, but the current template diff
 * module does not fetch its data from grapqhl, a necessity for the templateEdit preview.
 */

import styled from 'styled-components';
import { Markdown } from 'ui/markdown';
import { body2, colors, fontWeights } from 'ui/theme';

export const ChatTick = styled.div`
  width: 0px;
  height: 0px;
  border-bottom: 10px solid transparent;
  border-right: 10px solid ${colors.white};
  float: left;
`;

export const MessageBody = styled.div`
  align-items: flex-start;
  box-sizing: border-box;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  font-weight: ${fontWeights.regular};
  overflow-x: hidden;
  overflow-y: auto;
  padding: 12px 4px;
  width: 100%;
`;

export const MessageContentHeader = styled.div`
  font-weight: ${fontWeights.semiBold};
  margin-bottom: 8px;
  ${body2}
`;

export const MessageBodyMedia = styled.img`
  border-radius: 7px;
  flex: 0 0 auto;
  margin-top: 7px;
  width: 100%;
`;

export const MessageBodyWhatsAppMessageContainer = styled.div`
  display: flex;
  flex: 0 0 auto;
  line-height: 1.4;
  width: 100%;
`;

export const MessageBodyWhatsAppMessage = styled.div`
  background-color: ${colors.white};
  border-radius: 4px;
  border-top-left-radius: 0;
  color: ${colors.black};
  flex: 0 0 auto;
  font-size: 12px;
  width: 80%;
  overflow-wrap: break-word;
  padding: 8px;
  white-space: pre-wrap;
`;

export const StyledMarkdown = styled(Markdown)`
  line-height: 0;
`;
